const state = {}

const getters = {}

const actions = {
  completeForm () {
    return new Promise((resolve, reject) => {
      resolve()
    })
  },
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
